// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';
import { Stack, CircularProgress, Typography } from '@metarouter-private/mr-mui';

export default function UploadProgress({ pipelineCount }) {
  return (
    <Stack spacing={2} alignItems="center">
      <CircularProgress />
      <Typography variant="body1">Processing {pipelineCount} pipelines...</Typography>
    </Stack>
  );
}

UploadProgress.propTypes = {
  pipelineCount: PropTypes.number.isRequired,
};
